<template>
  <div id="postPortfolio">
    <div>
      <div class="steps-header-container">
        <el-steps :active="currentstep" finish-status="success">
          <!--                    description="Some description"-->
          <el-step title="Step 1"></el-step>
          <el-step title="Step 2"></el-step>
          <el-step title="Step 3"></el-step>
        </el-steps>
      </div>

      <div class="steps-content-container">
        <div class="post-step-1" v-if="currentstep === 0">
          <div class="images-container">
            <div class="images-header-container" style="min-height: 40px">
              <!--                        <div class="images-header-container" v-if="arrobj_SelectedFiles != null && arrobj_SelectedFiles.length > 0">-->
              <button class="btn btn-primary" @click="showGalleryList()" v-if="arrobj_SelectedFiles.length === 0" style="display: inline-block; float: left">
                <span>{{ lang('Upload from gallery') }}</span>
              </button>

              <!--                            style="float: right;"-->
              <button class="btn btn-danger" @click="clearPreview" v-if="arrobj_SelectedFiles != null && arrobj_SelectedFiles.length > 0">
                <i class="fa fa-ban" aria-hidden="true"></i>
                <span style="margin-left: 5px">{{ lang('Remove All') }}</span>
              </button>
            </div>

            <div class="upload-file-list-container">
              <div
                class="each-file-container"
                v-if="arrobj_SelectedFiles != null && arrobj_SelectedFiles.length > 0"
                v-for="(file, key) in arrobj_SelectedFiles"
                :key="(file, key).id"
              >
                <span class="each-file">
                  <img slot="img" class="img-fluid preview" v-if="checkIfImage(file)" v-bind:ref="'image' + parseInt(key)" />

                  <video
                    class="media-file-video preview"
                    v-if="!checkIfImage(file) && file.type.toLowerCase() !== 'application/pdf'"
                    controls
                    style="max-width: 100%"
                    v-bind:ref="'video' + parseInt(key)"
                    :type="file.type.toLowerCase()"
                  ></video>

                  <pdf
                    class="media-file-video preview"
                    v-if="!checkIfImage(file) && file.type.toLowerCase() === 'application/pdf'"
                    style="max-width: 100%; overflow: auto"
                    v-bind:ref="'pdf' + parseInt(key)"
                    :type="file.type.toLowerCase()"
                  ></pdf>
                </span>

                <span class="each-file-close" @click="removeEachFile(file)" :id="(file, key).id"><strong>x</strong></span>
              </div>
            </div>
          </div>

          <div class="col-md-6 formDiv" :class="{ 'form-group--error': $v.obj_Post.PostPorDtlTitle.$error }">
            <label for="tb_Title">{{ lang('Title') }}</label>
            <input
              v-model="obj_Post.PostPorDtlTitle"
              type="text"
              class="form-control"
              id="tb_Title"
              :placeholder="lang('Please enter a title')"
              v-model.trim="$v.obj_Post.PostPorDtlTitle.$model"
            />

            <div class="error requiredFieldsMsg" v-if="!$v.obj_Post.PostPorDtlTitle.required">
              <el-alert :title="lang('Title is required')" type="error"> </el-alert>
            </div>
          </div>

          <div class="col-md-6 formDiv" :class="{ 'form-group--error': $v.arr_ddlInquiryCycle.$error }">
            <label>{{ lang('Inquiry Cycle') }}</label>
            <el-select
              v-model="arr_ddlInquiryCycle"
              :placeholder="lang('Inquiry Cycle')"
              class="w-100"
              multiple
              style="margin-bottom: 20px"
              v-model.trim="$v.arr_ddlInquiryCycle.$model"
            >
              <el-option
                v-for="item in ddlInquiryCycleList"
                class="ddlInquiryCycleOption"
                :key="item.PortfolioItemMasterID"
                :label="item.PortfolioItemMasterValue"
                :value="item.PortfolioItemMasterValue"
              >
              </el-option>
            </el-select>

            <div class="error requiredFieldsMsg" v-if="!$v.arr_ddlInquiryCycle.required">
              <el-alert title="Inquiry Cycle is required!" type="error"> </el-alert>
            </div>
          </div>

          <div class="col-md-6 formDiv" :class="{ 'form-group--error': $v.ddlClass.$error }">
            <label>{{ lang('Class') }}</label>
            <el-select
              v-model="ddlClass"
              :placeholder="lang('Select Class')"
              style="margin-bottom: 20px"
              class="w-100"
              @change="changeClass()"
              v-model.trim="$v.ddlClass.$model"
            >
              <el-option
                v-for="item in ddlClassList"
                :key="item.PK_Class_ID"
                :label="item.CLS_ClassName.trim() + ' ' + item.CLS_Batch.trim()"
                :value="item.PK_Class_ID.trim()"
              >
              </el-option>
            </el-select>

            <div class="error requiredFieldsMsg" v-if="!$v.ddlClass.required">
              <el-alert title="Class is required!" type="error"> </el-alert>
            </div>
          </div>

          <div class="col-md-6 formDiv" :class="{ 'form-group--error': $v.porResearchQuestion.$error }">
            <label>{{ lang('Research Question') }}</label>
            <el-input v-model="porResearchQuestion" type="textarea"></el-input>

            <div class="error requiredFieldsMsg" v-if="!$v.porResearchQuestion.required" style="margin-top: 20px">
              <el-alert title="Research Question is required!" type="error"> </el-alert>
            </div>
          </div>

          <div class="col-md-12 formDiv" style="margin-top: 20px">
            <tags-component :parent_Post="post" @tags="setPortfolioTags" :portfolio_Type="portfolio_Type" ref="studentListComponent"></tags-component>
          </div>
        </div>

        <div class="post-step-2" v-if="currentstep === 1">
          <div class="col-md-6 formDiv">
            <label>{{ lang('Enduring Themes') }}</label>
            <el-select v-model="ddlEnduringThemes" :placeholder="lang('Enduring Themes')" style="margin-bottom: 20px" class="w-100">
              <el-option
                v-for="item in ddlEnduringThemesList"
                class="ddlEnduringThemesOption"
                :key="item.PortfolioItemMasterID"
                :label="item.PortfolioItemMasterValue"
                :value="item.PortfolioItemMasterValue"
              >
              </el-option>
            </el-select>
          </div>

          <div class="col-md-6 formDiv">
            <label>{{ lang('Big Ideas') }}</label>
            <el-select v-model="ddlBigIdeas" :placeholder="lang('Big Ideas')" style="margin-bottom: 20px" class="w-100">
              <el-option
                v-for="item in ddlBigIdeasList"
                class="ddlBigIdeasOption"
                :key="item.PortfolioItemMasterID"
                :label="item.PortfolioItemMasterValue"
                :value="item.PortfolioItemMasterValue"
              >
              </el-option>
            </el-select>
          </div>

          <div class="col-md-6 formDiv">
            <label>{{ lang('Key Concepts') }}</label>
            <el-select
              v-model="ddlKeyConcepts"
              :placeholder="lang('Key Concepts')"
              style="margin-bottom: 20px"
              class="w-100"
              @change="bindDropdownList('KeyConceptsRelated')"
            >
              <el-option
                v-for="(item, iIndex) in ddlKeyConceptsList"
                class="ddlKeyConceptsOption"
                :key="iIndex"
                :label="item.PortfolioItemMasterType2"
                :value="item.PortfolioItemMasterType2"
              >
              </el-option>
            </el-select>
          </div>

          <div class="col-md-6 formDiv" v-if="ddlKeyConcepts !== ''" style="vertical-align: bottom">
            <!--                        <label>{{lang("Key Concepts")}} Related</label>-->
            <el-select v-model="ddlRelatedKeyConcepts" :placeholder="lang('Key Concepts') + ' Related'" style="margin-bottom: 20px" class="w-100">
              <!--                            @change="generateSelectedList()"-->
              <el-option
                v-for="item in ddlRelatedKeyConceptsList"
                class="ddlKeyConceptsOption"
                :key="item.PortfolioItemMasterID"
                :label="item.PortfolioItemMasterValue"
                :value="item.PortfolioItemMasterValue"
              >
              </el-option>
            </el-select>
          </div>

          <div class="col-md-12 formDiv" v-if="ddlRelatedKeyConcepts !== ''">
            <el-button style="float: right" @click="generateSelectedList()">{{ lang('Add') }}</el-button>
          </div>

          <div class="selected-portfolio-table-container" v-if="arr_selectedPorfolioDetails.length > 0" style="">
            <data-tables :data="arr_selectedPorfolioDetails" :action-col="portfolioValueTableAction">
              <el-table-column v-for="info in selectedPortfolioValueTable" :prop="info.prop" :label="info.label" :key="info.prop" sortable="custom">
              </el-table-column>
            </data-tables>
          </div>
        </div>

        <div class="post-step-3" v-if="currentstep === 2">
          <div class="col-md-12 formDiv" style="margin-bottom: 20px">
            <!--                        ( <i class="material-icons">assignment_ind</i> = Assigned )-->
            <label>{{ lang('Developmental Goals') }}</label>

            <div class="col-md-6 formDiv" style="padding-left: 0px">
              <el-select v-model="porDevelopmentDomain" placeholder="Select Domain" class="w-100" @change="loadIndicator(porDevelopmentDomain)">
                <el-option
                  v-for="(item, index) in porDevelopmentDomainList"
                  class="ddlDevelopmentDomainOption"
                  :key="index"
                  :label="item.Str_SortBy"
                  :value="item.Str_SortBy"
                >
                </el-option>
              </el-select>
            </div>

            <div class="col-md-6 formDiv" style="padding-left: 0px">
              <el-select v-model="porDevelopmentIndicator" placeholder="Select Indicator" class="w-100" @change="setValidateDropdown(porDevelopmentIndicator)">
                <!--                            <el-select v-model="obj_Post.PostPorDtlDevelopmentGoals" placeholder="Select Indicator" multiple-->
                <!--                                       class="w-100" @change="setValidateDropdown(obj_Post.PostPorDtlDevelopmentGoals)">-->
                <el-option
                  v-for="(item, index) in porDevelopmentIndicatorList"
                  class="ddlDevelopmentIndicatorOption"
                  :key="item.PlnStaIndicator.trim()"
                  :label="item.PlnStaIndicator.trim()"
                  :value="item.PlnStaIndicator.trim()"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div v-if="porDevelopmentObject.length > 0" class="col-md-12 formDiv" style="margin-bottom: 20px">
            <label>{{ lang('You have selected') }}</label>

            <table class="w-100">
              <thead class="table-thead">
                <tr class="table-tr">
                  <th class="table-th">{{ lang('Domain') }}</th>
                  <th class="table-th">{{ lang('Goals') }}</th>
                  <th class="table-th">{{ lang('Indicator') }}</th>
                  <th class="table-th">{{ lang('Action') }}</th>
                </tr>
              </thead>

              <tr v-for="(porDevelopmentObjectValueInfo, index) in porDevelopmentObject" style="border-bottom: 1px solid #e4e7ed">
                <td class="table-td">{{ porDevelopmentObjectValueInfo.Domain }}</td>
                <td class="table-td">{{ porDevelopmentObjectValueInfo.Goals }}</td>
                <td class="table-td">
                  <input
                    type="text"
                    class="form-control"
                    :value="porDevelopmentObjectValueInfo.Indicator"
                    style="margin: 0px"
                    @blur="setAnalysisValue($event, index)"
                  />
                </td>
                <td class="table-td" style="padding: 10px 0px">
                  <el-button @click="removeSelectedGoals(porDevelopmentObjectValueInfo, index)">{{ lang('Delete') }}</el-button>
                </td>
              </tr>
            </table>
          </div>

          <div class="col-md-12 formDiv">
            <label for="tb_Observation">{{ lang('Observations') }}</label>
            <textarea
              rows="4"
              v-model="obj_Post.PostPorDtlObservation"
              type="text"
              class="form-control"
              id="tb_Observation"
              :placeholder="lang('Please enter your observations')"
            ></textarea>
          </div>

          <div class="col-md-12 formDiv">
            <label>{{ lang('Analysis') }}</label>
            <textarea
              rows="4"
              v-model="obj_Post.PostPorDtlAnalysisReflection"
              type="textarea"
              class="form-control"
              :placeholder="lang('Analysis')"
              readonly="readonly"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="step-footer-container" style="margin: 0 auto; width: 50%; padding: 15px">
        <el-button style="margin-top: 12px" @click="back" v-if="currentstep === 0">{{ lang('Back') }}</el-button>
        <el-button style="margin-top: 12px" @click="previous" v-if="currentstep > 0">Previous step</el-button>
        <el-button style="margin-top: 12px" @click="next" v-if="currentstep < 2">Next step</el-button>
        <el-button style="margin-top: 12px" @click="verifyPost" v-if="currentstep === 2">{{ lang('Submit') }}</el-button>
      </div>
    </div>

    <!--            Gallery List Modal-->
    <b-modal id="modal_GalleryListModal" hide-footer size="lg" title="New Post" ref="ref_modal_GalleryListModal" centered v-model="isModalOpen">
      <component
        :is="obj_SelectedComponent"
        :arrobjFolderPath="arrobj_FolderPath"
        v-on:childToParent="getChildtoParent"
        :displayListMode="displayListMode"
        @hidden="hideComponentModal"
      >
        <!--                    v-on:childToParent="getChildtoParent"
                        :arrobjFolderPath="arrobj_FolderPath"
                        :displayListMode="displayListMode"
                        :arrobjFolders="arrobj_Folders"
                        :arrobjFiles="arrobj_Files"
                        :intStartRowNo="int_StartRowNo"
                        :intEndRowNo="int_EndRowNo"-->
      </component>
    </b-modal>
  </div>
</template>

<script>
'use strict'
import DataSource from '../data/datasource'
import $ from 'jquery'
import { required, requiredIf, requiredUnless, email } from 'vuelidate/lib/validators'
import * as vm from 'vue'
import { lang } from '../locale/index'
import tagsComponent from '../components/Post_Tags_Component'
import galleryListComponent from '../components/galleryListComponent'
import pdf from 'vue-pdf'

export default {
  name: 'PostPortfolio',
  components: {
    tagsComponent,
    pdf,
  },
  data() {
    return {
      currentstep: 0,
      obj_Post: {
        PostID: '',
        PostPorDtlTitle: '',
        PostPorDtlObservation: '',
        PostPorDtlAnalysisReflection: '',
        PostPorDtlDevelopmentGoals: [],
      },
      arr_ddlInquiryCycle: [],
      ddlInquiryCycleList: [],
      ddlClass: '',
      ddlClassList: [],
      portfolio_Type: 'Yes',
      arrobj_SelectedStudents: [],
      arrobj_SelectedFiles: [],

      defaultDropdownType: 'InquiryCycle',
      defaultDropdownType2: '',
      arrEnduringThemesSelection: [],
      ddlEnduringThemes: '',
      ddlEnduringThemesList: [],
      arrBigIdeasSelection: [],
      ddlBigIdeas: '',
      ddlBigIdeasList: [],
      arrKeyConceptsSelection: [],
      ddlKeyConcepts: '',
      ddlKeyConceptsList: [],
      arrRelatedKeyConceptsSelection: [],
      ddlRelatedKeyConcepts: '',
      ddlRelatedKeyConceptsList: [],

      arr_selectedPorfolioDetails: [],
      selectedPortfolioValueTable: [
        {
          prop: 'EnduringThemes',
          label: lang('Enduring Themes'),
        },
        {
          prop: 'BigIdeas',
          label: lang('Big Ideas'),
        },
        {
          prop: 'Concepts',
          label: lang('Key Concepts'),
        },
        {
          prop: 'ConceptsRelated',
          label: lang('Key Concepts') + ' Related',
        },
      ],
      portfolioValueTableAction: {
        label: lang('Action'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-delete',
            },

            handler: row => {
              this.arr_selectedPorfolioDetails.splice(this.arr_selectedPorfolioDetails.indexOf(row), 1)
            },
            label: '',
          },
        ],
      },
      porDevelopmentObject: [],
      porDevelopmentObjectValue: [
        {
          prop: 'Domain',
          label: lang('Domain'),
        },
        {
          prop: 'Goals',
          label: lang('Goals'),
        },
        {
          prop: 'Indicator',
          label: lang('Indicator'),
        },
      ],
      porDevelopmentDomain: '',
      porDevelopmentDomainList: [],
      porDevelopmentIndicator: '',
      porDevelopmentIndicatorList: [],

      ddlGoalsList: [],
      sortedGoalList: [],
      arrobj_selectedInquiryCycle: [],
      arr_indicatorList: [],

      selectedConcepts: '',
      isValid: false,

      /* Gallery List variable */
      obj_SelectedComponent: false,
      isModalOpen: false,
      arrobj_FolderPath: [{ GalFolder: lang('Gallery'), GalID: 'PRIMARY', GalType: 'Folder' }],
      displayListMode: 'Portfolio',
      /* Gallery List variable */
      porResearchQuestion: '',
    }
  },
  methods: {
    lang,

    async bindClasses() {
      try {
        this.ddlClassList = []

        const response = await DataSource.shared.getAttendanceClass()
        if (response) {
          this.class = response.Table
          this.class.forEach(m => {
            this.ddlClassList.push(m)
          })
        }
      } catch (e) {
        this.results = e
      }
    }, // get all the class list

    async bindDropdownList(val) {
      if (!this.isNull(val)) {
        this.defaultDropdownType = val
      }

      if (this.defaultDropdownType === 'KeyConcepts') {
        this.defaultDropdownType2 = 'KeyConcepts'
      } else if (this.defaultDropdownType === 'KeyConceptsRelated') {
        this.defaultDropdownType = 'KeyConcepts'
        this.defaultDropdownType2 = this.ddlKeyConcepts
      }

      let classID = ''
      if (this.defaultDropdownType === 'BigIdeas') {
        classID = this.ddlClass
      }

      try {
        const response = await DataSource.shared.getPortfolioItemMaster(this.defaultDropdownType, this.defaultDropdownType2, classID)
        if (response) {
          if (this.defaultDropdownType === 'InquiryCycle') {
            this.ddlInquiryCycleList = response.Table
          } else if (this.defaultDropdownType === 'EnduringThemes') {
            this.ddlEnduringThemesList = response.Table
          } else if (this.defaultDropdownType === 'BigIdeas') {
            this.ddlBigIdeasList = response.Table
          } else if (this.defaultDropdownType === 'KeyConcepts') {
            if (this.defaultDropdownType2 === 'KeyConcepts') {
              this.ddlKeyConceptsList = response.Table
            } else {
              this.ddlRelatedKeyConceptsList = response.Table
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    }, // get different type of dropdown list

    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer()
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType === 'audio/vnd.dlna.adts' ? 'audio/aac' : mimeType })
          // return new File([buf], filename, {type: mimeType});
        })
    }, // convert uploaded url to file format

    getImagePreviews() {
      /*
                  Iterate over all of the files and generate an image preview for each one.
                */
      for (let i = 0; i < this.arrobj_SelectedFiles.length; i++) {
        /*
                      Ensure the file is an image file
                    */
        if (/\.(jpe?g|png|gif)$/i.test(this.arrobj_SelectedFiles[i].name)) {
          /*
                          Create a new FileReader object
                        */
          let reader = new FileReader()

          /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
          reader.addEventListener(
            'load',
            function () {
              this.$refs['image' + parseInt(i)][0].src = reader.result
            }.bind(this),
            false,
          )

          /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
          reader.readAsDataURL(this.arrobj_SelectedFiles[i])
        }

        if (/\.(mp4|mp3|aac|wav)$/i.test(this.arrobj_SelectedFiles[i].name)) {
          /*
                          Create a new FileReader object
                        */
          let reader = new FileReader()
          /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
          reader.addEventListener(
            'load',
            function () {
              this.$refs['video' + parseInt(i)][0].src = reader.result
            }.bind(this),
            false,
          )

          /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
          reader.readAsDataURL(this.arrobj_SelectedFiles[i])
        }

        if (/\.(pdf)$/i.test(this.arrobj_SelectedFiles[i].name)) {
          /*
                          Create a new FileReader object
                        */
          let reader = new FileReader()

          /*
                          Add an event listener for when the file has been loaded
                          to update the src on the file preview.
                        */
          reader.addEventListener(
            'load',
            function () {
              this.$refs['pdf' + parseInt(i)][0].src = reader.result
            }.bind(this),
            false,
          )

          /*
                          Read the data for the file in through the reader. When it has
                          been loaded, we listen to the event propagated and set the image
                          src to what was loaded from the reader.
                        */
          reader.readAsDataURL(this.arrobj_SelectedFiles[i])
        }
      }
    }, // check files type and bind src for display

    clearPreview() {
      $('#FU_Portfolio').val('')
      this.arrobj_SelectedFiles = []
    }, // selected files set to empty

    checkIfImage(file) {
      const fileType = file.type.toLowerCase()
      switch (fileType) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/jpg':
        case 'image/gif':
          return true
        default:
          return false
      }
    }, // check files type whether is image

    removeEachFile(objFile) {
      this.arrobj_SelectedFiles = this.arrobj_SelectedFiles.filter(d => {
        return d.name !== objFile.name
      })
      this.getImagePreviews()
    }, // remove each files that selected

    setPortfolioTags(value) {
      this.arrobj_SelectedStudents = value
      this.getPlannerAssignedStudentsGroupByClassID(this.arrobj_SelectedStudents)
    },

    changeClass() {
      this.$refs.studentListComponent.filterByClassIDChange(this.ddlClass)
      this.getPlannerAssignedStudentsGroupByClassID('')
      this.porDevelopmentDomain = ''
      this.porDevelopmentIndicator = ''
      this.porDevelopmentIndicatorList = []
      this.porDevelopmentObject = []
      this.obj_Post.PostPorDtlAnalysisReflection = ''
    },

    async getPlannerAssignedStudentsGroupByClassID(studentID) {
      try {
        if (studentID === '') {
          const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassID(this.ddlClass, '')

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('getPlannerAssignedStudentsGroupByClassID Error')
            } else if (response.code === '2') {
              this.obj_Post.PostPorDtlDevelopmentGoals = []
              this.ddlGoalsList = []
            } else {
              this.obj_Post.PostPorDtlDevelopmentGoals = []
              this.ddlGoalsList = response.Table
            }
          }
        } else {
          //reset all to No
          this.ddlGoalsList = this.ddlGoalsList.map(m => {
            m.Included = 'No'
            return m
          })
          //reset all to No

          let StudentIDList = []

          studentID.forEach(item => {
            let tempStudentIDList = {
              StudentID: item,
            }

            StudentIDList.push(tempStudentIDList)
          })

          if (StudentIDList.length > 0) {
            const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassID(this.ddlClass, JSON.stringify(StudentIDList))

            if (response) {
              if (response.code === '88') {
                window.location.replace('/')
              } else if (response.code === '99') {
                console.log('getPlannerAssignedStudentsGroupByClassID Error')
              } else if (response.code === '2') {
                console.log('getPlannerAssignedStudentsGroupByClassID no record')
              } else {
                //set those available to Yes
                response.Table.forEach(item => {
                  this.ddlGoalsList = this.ddlGoalsList.map(m => {
                    if (m.PlnStaIndicator === item.PlnStaIndicator) {
                      m.Included = 'Yes'
                    }
                    return m
                  })
                })
                //set those available to Yes
              }
            }
          }
        }

        this.ddlGoalsList.forEach((goal, gIndex) => {
          goal.KeyId = gIndex + 1
        })

        this.loadDomainList()
      } catch (e) {
        this.results = e
      }
    },

    loadDomainList() {
      let sortedList = this.groupBy(this.ddlGoalsList, 'PlnStaDomain')

      this.porDevelopmentDomainList = []

      sortedList.forEach(item => {
        this.porDevelopmentDomainList.push(item)
      })
    },

    groupBy(data, key) {
      let ArrObj_Sorted = []

      for (let item of data) {
        let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key])

        if (index === -1) {
          ArrObj_Sorted.push({ Str_SortBy: item[key], ArrObj_Items: [item] })
        } else ArrObj_Sorted[index].ArrObj_Items.push(item)
      }

      return ArrObj_Sorted
    },

    generateSelectedList() {
      if (this.ddlEnduringThemes !== '' && this.ddlBigIdeas && this.ddlKeyConcepts && this.ddlRelatedKeyConcepts) {
        let obj_SelectedPortfolioDetails = {
          EnduringThemes: this.ddlEnduringThemes,
          BigIdeas: this.ddlBigIdeas,
          Concepts: this.ddlKeyConcepts,
          ConceptsRelated: this.ddlRelatedKeyConcepts,
        }

        let isDuplicate = false
        if (this.arr_selectedPorfolioDetails.length > 0) {
          this.arr_selectedPorfolioDetails.forEach(item => {
            if (
              item.EnduringThemes === this.ddlEnduringThemes &&
              item.BigIdeas === this.ddlBigIdeas &&
              item.Concepts === this.ddlKeyConcepts &&
              item.ConceptsRelated === this.ddlRelatedKeyConcepts
            ) {
              isDuplicate = true
            }
          })
        }

        if (!isDuplicate) {
          this.arr_selectedPorfolioDetails.push(obj_SelectedPortfolioDetails)
        }

        this.ddlEnduringThemes = ''
        this.ddlBigIdeas = ''
        this.ddlKeyConcepts = ''
        this.ddlRelatedKeyConcepts = ''
      } else {
        this.$notify.error({
          title: 'Error',
          message: 'Please select all dropdown!',
        })
      }
    },

    loadIndicator(value) {
      this.porDevelopmentIndicatorList = []

      this.porDevelopmentDomainList.forEach(item => {
        if (item.Str_SortBy === value) {
          this.porDevelopmentIndicatorList = item.ArrObj_Items
        }
      })
    },

    setValidateDropdown(value) {
      if (this.porDevelopmentIndicator !== '') {
        if (!this.arr_indicatorList.includes(this.porDevelopmentIndicator)) {
          this.arr_indicatorList.push(this.porDevelopmentIndicator)
        }
      }
      this.porDevelopmentObject = []
      this.obj_Post.PostPorDtlAnalysisReflection = ''

      this.arr_indicatorList.forEach((indicator, iIndex) => {
        this.ddlGoalsList.forEach(m => {
          if (indicator === m.PlnStaIndicator) {
            let porDevelopmentObjectTemp = {
              Domain: m.PlnStaDomain,
              Goals: m.PlnStaGoals,
              Indicator: m.PlnStaIndicator,
              KeyId: m.KeyId,
            }

            this.porDevelopmentObject.push(porDevelopmentObjectTemp)

            this.obj_Post.PostPorDtlAnalysisReflection += m.PlnStaIndicator + '\n'
          }
        })
      })

      this.porDevelopmentDomain = ''
      this.porDevelopmentIndicator = ''
      this.porDevelopmentIndicatorList = []

      this.loadDomainList()
    },

    removeSelectedGoals(itemValue, itemIndex) {
      this.ddlGoalsList.forEach((d, dIndex) => {
        if (itemValue.KeyId === d.KeyId) {
          this.arr_indicatorList = this.arr_indicatorList.filter((indicator, iIndex) => {
            return indicator !== d.PlnStaIndicator
          })
        }
      })

      this.setValidateDropdown(this.ddlGoalsList)
    },

    setAnalysisValue(event, objIndex) {
      let editedText = ''
      if (!this.isNull(event)) {
        editedText = event.target.value
      }

      this.obj_Post.PostPorDtlAnalysisReflection = ''

      this.porDevelopmentObject.forEach((val, index) => {
        if (objIndex !== '' && index === objIndex && val.Indicator !== editedText) {
          val.Indicator = editedText

          this.arr_indicatorList[objIndex] = editedText

          let porDevelopmentObjectTemp = {
            PlnStaDomain: val.Domain,
            PlnStaGoals: val.Goals,
            PlnStaIndicator: val.Indicator,
            Included: 'No',
            KeyId: this.ddlGoalsList.length + 1,
          }

          this.ddlGoalsList.push(porDevelopmentObjectTemp)
        }
        this.obj_Post.PostPorDtlAnalysisReflection += val.Indicator + '\n'
      })

      this.setValidateDropdown()
    },

    async verifyPost() {
      // if (this.currentstep === 2) {
      //     this.$vs.loading();
      // }
      this.$vs.loading()
      await this.sleep(200)

      try {
        // if (!this.$v.$error) {
        //     this.$vs.loading();
        // if (this.isNull(this.obj_Post.PostPorDtlTitle) ||
        //     this.isNull(this.obj_Post.PostPorDtlObservation) ||
        //     this.isNull(this.obj_Post.PostPorDtlAnalysisReflection) ||
        //     this.isNull(this.obj_Post.PostPorDtlDevelopmentGoals) ||
        //     this.isNull(this.arrobj_SelectedStudents) ||
        //     this.isNull(this.arrEnduringThemesSelection) ||
        //     this.isNull(this.arrBigIdeasSelection) ||
        //     this.isNull(this.arrKeyConceptsSelection)) {
        //
        //     setTimeout(() => {
        //         this.$vs.loading.close();
        //     }, 500);
        //
        //     // this.$emit("result", "FALSE");
        //     this.$notify.error({
        //         title: lang('Error'),
        //         message: lang('Please fill in content')
        //     });
        //     return;
        // }
        // await this.sleep(1000);
        if (
          this.isNull(this.obj_Post.PostPorDtlAnalysisReflection) ||
          this.isNull(this.obj_Post.PostPorDtlObservation) ||
          this.isNull(this.porDevelopmentObject)
        ) {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please fill in content'),
          })
          return
        } else {
          // this.$vs.loading();
        }

        this.arr_ddlInquiryCycle.forEach(item => {
          let objItem = {}
          objItem.Type = 'InquiryCycle'
          objItem.Value = item

          this.arrobj_selectedInquiryCycle.push(objItem)
        })

        const response = await DataSource.shared.savePortfolioPost(
          this.arrobj_SelectedFiles,
          this.obj_Post.PostPorDtlTitle,
          this.obj_Post.PostPorDtlObservation,
          this.obj_Post.PostPorDtlAnalysisReflection,
          JSON.stringify(this.porDevelopmentObject),
          this.arrobj_SelectedStudents,
          '',
          '',
          this.obj_Post.PostID,
          JSON.stringify(this.arrobj_selectedInquiryCycle),
          JSON.stringify(this.arr_selectedPorfolioDetails),
          this.porResearchQuestion,
        )

        if (response) {
          this.$vs.loading.close()
          if (response.code !== '1') {
            this.$notify.error({
              title: lang('Error'),
              message: lang('Save Error!'),
            })
            return
          }

          if (!this.isNull(response) && response.code === '1') {
            this.$notify({
              title: lang('Success'),
              message: lang('Portfolio added'),
              type: 'success',
            })
            this.$emit('result', 'TRUE')
            await DataSource.shared.softDeletePost(this.obj_Post.PostID)
          } else this.$emit('result', 'FALSE')

          // this.$router.go(-1);
          window.location.replace('/postportfolio')
        }

        // }
      } catch (e) {
        this.results = e
      }

      this.$vs.loading.close()
    },

    next() {
      try {
        this.$v.$touch()

        if (this.isNull(this.arrobj_SelectedFiles)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 image!',
          })
          return
        }

        if (this.$v.$error) {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill all field!',
          })
          return
        }

        if (this.isNull(this.arrobj_SelectedStudents)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 student!',
          })
          return
        }

        if (this.currentstep === 1 && this.isNull(this.arr_selectedPorfolioDetails)) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select the selection!',
          })
          return
        }

        if (this.currentstep++ > 2) this.currentstep = 0

        if (this.currentstep === 1) {
          if (this.isNull(this.ddlEnduringThemesList)) {
            this.bindDropdownList('EnduringThemes').then(enduring => {
              if (this.isNull(this.ddlBigIdeasList)) {
                this.bindDropdownList('BigIdeas').then(big => {
                  if (this.isNull(this.ddlKeyConceptsList)) {
                    this.bindDropdownList('KeyConcepts')
                  }
                })
              }
            })
          }
        }
      } catch (e) {
        console.log(e)
      }
    }, // next step
    previous() {
      if (this.currentstep-- < 0) this.currentstep = 0

      if (this.currentstep === 0) {
        this.getImagePreviews()

        this.$nextTick(() => {
          this.$refs.studentListComponent.filterByClassIDChange(this.ddlClass)
          this.arrobj_SelectedStudents = []
        })
      }
    }, // previous step
    back() {
      this.$router.go(-1)
    }, // back to newmedia page

    showGalleryList() {
      this.obj_SelectedComponent = galleryListComponent
      this.isModalOpen = true
    }, // show the gallery component modal
    hideComponentModal() {
      this.obj_SelectedComponent = false
      this.isModalOpen = false
    }, // hide the gallery component modal

    getChildtoParent(arrobjSelectedFile) {
      this.arrobj_SelectedFiles = []

      if (!this.isNull(arrobjSelectedFile)) {
        for (let image of arrobjSelectedFile) {
          // let url = "data:" + image.GalFileType + ";base64," + (!this.isMedia(image.GalFileExt) ? image.GalFileLow : image.GalFile);
          // let url = "data:" + image.GalFileType + ";base64," + image.GalFile;
          let url = image.FilePath
          let fileName = image.GalFileName + image.GalFileExt
          let mimeType = image.GalFileType

          this.urltoFile(url, fileName, mimeType)
            .then(file => {
              this.arrobj_SelectedFiles.push(file)
            })
            .finally(() => {
              this.getImagePreviews()
            })
        }
      }

      this.hideComponentModal()
    }, // get selected files from gallery component

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0
    }, // check the object whether got value

    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },
  },
  mounted() {
    this.bindClasses()

    this.bindDropdownList()

    if (!this.isNull(this.$route.params.images)) {
      this.arrobj_SelectedFiles = []
      for (let image of this.$route.params.images) {
        // let url = "data:" + image.GalFileType + ";base64," + image.GalFile;
        let url = image.FilePath
        let fileName = image.GalFileName + image.GalFileExt
        let mimeType = image.GalFileType
        this.urltoFile(url, fileName, mimeType)
          .then(file => {
            this.arrobj_SelectedFiles.push(file)
          })
          .finally(() => {
            this.getImagePreviews()
          })
      }
    } // load image

    if (!this.isNull(this.$route.params.displayMode)) {
      this.displayListMode = this.$route.params.displayMode
    } // set the mode for load gallery component
  },
  computed: {},
  validations: {
    obj_Post: {
      PostPorDtlTitle: {
        required,
      },
      // PostPorDtlObservation: {
      //     required
      // },
      // PostPorDtlDevelopmentGoals: {
      //     required
      // },
      // PostPorDtlAnalysisReflection: {
      //     required
      // }
    },
    arr_ddlInquiryCycle: {
      required,
    },
    ddlClass: {
      required,
    },
    porResearchQuestion: {
      required,
    },
  },
  props: ['post'],
}
</script>

<style scoped>
.steps-header-container {
  margin: 0 auto;
  width: 50%;
  padding: 15px;
}

.steps-content-container {
  display: inline-block;
  background: white;
  margin: 0 auto;
  width: 50%;
  padding: 15px;
}

.post-step-1,
.post-step-2 {
  text-align: left;
}

.images-header-container {
  margin-bottom: 20px;
  text-align: right;
}

.formDiv {
  display: inline-block;
  vertical-align: top;
}

.upload-file-list-container {
  display: inline-block;
  margin-bottom: 20px;
}

.each-file-container {
  display: inline-block;
  height: 200px;
  /*width: 200px;*/
  width: 190px;
  vertical-align: top;
  margin: 0 20px 20px 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  position: relative;
}

.each-file-container .each-file {
  display: block;
  height: 100%;
  width: 100%;
}

.each-file-container span img {
  object-fit: contain;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  padding: 10px;
}

.upload-file-box {
  width: 200px;
  height: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  padding: 80px 0;
}

.each-file-close {
  position: absolute;
  top: -15px;
  right: -5px;
  background: white;
  width: 30px;
  height: 30px;
  padding: 0 10px;
  border-radius: 50%;
  border: 1px solid #ccc;
  display: block;
  cursor: pointer;
}

.media-file-video {
  max-width: 100%;
  height: 100%;
  padding: 10px;
  border-radius: 6px;
  object-fit: contain;
}

.table-th {
  text-align: center;
}
</style>

<style>
#postPortfolio .el-step__line-inner {
  width: 0% !important;
}

#postPortfolio .el-step:last-of-type .el-step__icon.is-text {
  margin-left: unset;
}
</style>
